import lazyScreen from '../utils/lazyScreen';
const Customers = lazyScreen(() => import('../pages/crm/Customers/index.js'), 'pages/crm/Customers/index.js');
const Customer = lazyScreen(() => import('../pages/crm/Customer/index.js'), 'pages/crm/Customer/index.js');
const CRMLeads = lazyScreen(() => import('../pages/crm/CRMLeads/index.js'), 'pages/crm/CRMLeads/index.js');
const CRMLead = lazyScreen(() => import('../pages/crm/CRMLead/index.js'), 'pages/crm/CRMLead/index.js');
const CRMLeadIntake = lazyScreen(() => import('../pages/crm/CRMLeadIntake/index.js'), 'pages/crm/CRMLeadIntake/index.js');
const CRMLeadActivities = lazyScreen(() => import('../pages/crm/CRMLeadActivities/index.js'), 'pages/crm/CRMLeadActivities/index.js');
const CRMTickets = lazyScreen(() => import('../pages/crm/CRMTickets/index.js'), 'pages/crm/CRMTickets/index.js');
const CRMTicket = lazyScreen(() => import('../pages/crm/CRMTicket/index.js'), 'pages/crm/CRMTicket/index.js');
const CRMCampaigns = lazyScreen(() => import('../pages/crm/CRMCampaigns/index.js'), 'pages/crm/CRMCampaigns/index.js');
const CustomerCard = lazyScreen(() => import('../pages/crm/CustomerCard/index.js'), 'pages/crm/CustomerCard/index.js');

export default [
    {
        path: '/crm/Customers',
        component: Customers
    },
    {
        path: '/crm/Customer/:code',
        component: Customer
    },
    {
        path: '/crm/CRMLeads',
        component: CRMLeads
    },
    {
        path: '/crm/CRMLeadIntake',
        component: CRMLeadIntake
    },
    {
        path: '/crm/CRMLead/:id',
        component: CRMLead
    },
    {
        path: '/crm/CRMLeadActivities',
        component: CRMLeadActivities
    },
    {
        path: '/crm/CRMTickets',
        component: CRMTickets
    },
    {
        path: '/crm/CRMTicket/:code',
        component: CRMTicket
    },
    {
        path: '/crm/CRMCampaigns',
        component: CRMCampaigns
    },
    {
        path: '/crm/CustomerCard/:code',
        component: CustomerCard
    }
];
